import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class AdminUserApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.MANAGEMENT_USER);
  }

  updatePermissions(userId, permissions) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${userId}/permissions`,
      { permissions },
    );
  }
}

export default new AdminUserApi();
